module.exports = __webpack_public_path__ + "static/media/hero_mobile.be435008.webp";